import { createIcon } from './icon-utils';

export const NotStaleIcon = createIcon({
  fill: '#009C64',
  path: 'M6.45 17.25L5.025 14.85L2.325 14.25L2.5875 11.475L0.75 9.375L2.5875 7.275L2.325 4.5L5.025 3.9L6.45 1.5L9 2.5875L11.55 1.5L12.975 3.9L15.675 4.5L15.4125 7.275L17.25 9.375L15.4125 11.475L15.675 14.25L12.975 14.85L11.55 17.25L9 16.1625L6.45 17.25ZM8.2125 12.0375L12.45 7.8L11.4 6.7125L8.2125 9.9L6.6 8.325L5.55 9.375L8.2125 12.0375Z',
  style: {
    height: 18,
    width: 18,
  },
  viewBox: '0 0 18 18',
});
